import React from 'react';
import styled from 'styled-components';
import { Carousel as AntdCarousel } from 'antd';
import ProductHead01 from '../../../assets/preview-image-01.png';
import ProductHead02 from '../../../assets/preview-image-02.png';
import ProductHead03 from '../../../assets/preview-image-03.png';
import ProductHead04 from '../../../assets/preview-image-04.png';
import ProductHead05 from '../../../assets/preview-image-05.png';
import ProductHead06 from '../../../assets/preview-image-06.png';
import ProductHead07 from '../../../assets/preview-image-07.png';

const CarouselWrapper = styled.div`
  max-width: 500px;
  min-width: 375px;
  width: 100%;
  margin: 0 auto;
  position: relative;
`;

const Slide = styled.div`
  border-radius: 10px;
  overflow: hidden;
`;

const SlideImg = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
  border-radius: 20px;
`;

const Arrow = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 2;
  font-size: 40px;
  font-weight: bold;
  padding: 0.25em 0.5em;
  color: #333;
`;

const NextArrow = styled(Arrow)`
  right: 20px;
`;

const PrevArrow = styled(Arrow)`
  left: 20px;
`;

export default function Carousel() {
  const carouselRef = React.useRef<any>(null);

  const next = () => {
    if (carouselRef.current) {
      carouselRef.current.next();
    }
  };

  const prev = () => {
    if (carouselRef.current) {
      carouselRef.current.prev();
    }
  };

  return (
    <CarouselWrapper>
      <AntdCarousel ref={carouselRef} autoplay autoplaySpeed={5000} dots arrows={false}>
        {[ProductHead01, ProductHead02, ProductHead03, ProductHead04, ProductHead05, ProductHead06, ProductHead07].map((img, idx) => (
          <Slide key={idx}>
            <SlideImg src={img} alt={`Product Image ${idx + 1}`} />
          </Slide>
        ))}
      </AntdCarousel>
      <PrevArrow onClick={prev}>‹</PrevArrow>
      <NextArrow onClick={next}>›</NextArrow>
    </CarouselWrapper>
  );
}